import { API } from "../../api";
async function sign_up(request) {
    return await new API().apiPost({
        baseUrl: process.env.LETS_TRADE_USER_URL ?? "",
        endpoint: `v2/user/sign/up`,
        content: request,
    });
}
export { sign_up };
